import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { CategoryPicker } from "@/components/CategoryPicker";

const FIELDS = [
  ["company_name", "Company Name"], ["first_name", "Contact First Name"], ["job_title", "Job Title"],
  ["last_name", "Contact Last Name"], ["email", "Email Address"], ["telephone", "Telephone"], ["website", "Company Website"], ["source", "Source"],
];

export default function LeadFormDialog({ open, onOpenChange, lead, onSaved }) {
  const [form, setForm] = useState(lead || {});
  const [busy, setBusy] = useState(false);
  const [camps, setCamps] = useState([]);
  useEffect(() => { if (open) { api.get("/campaigns").then((r) => setCamps(r.data)); if (lead) setForm(lead); } }, [open, lead]);
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = lead ? await api.patch(`/leads/${lead.id}`, form) : await api.post("/leads", form);
      toast.success(lead ? "Lead updated" : "Lead created"); onOpenChange(false); onSaved?.(data); if (!lead) setForm({});
    } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (o) setForm(lead || {}); onOpenChange(o); }}>
      <DialogContent className="max-w-xl" data-testid="lead-form-dialog">
        <DialogHeader><DialogTitle>{lead ? "Edit lead" : "New lead"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid sm:grid-cols-2 gap-3">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={k === "company_name" || k === "website" ? "sm:col-span-2" : ""}>
              <div className="label-xs mb-1">{label}</div>
              <Input data-testid={`lead-form-${k}`} value={form[k] || ""} type={k === "email" ? "email" : "text"}
                required={k === "company_name" || (k === "email" && !lead)} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
            </div>
          ))}
          <div className="sm:col-span-2"><div className="label-xs mb-1">Business Categories</div>
            <CategoryPicker value={form.business_categories || []} onChange={(v) => setForm({ ...form, business_categories: v })} testid="lead-form-categories" /></div>
          <div className="sm:col-span-2"><div className="label-xs mb-1">Campaign</div>
            <Select value={form.campaign_id || "none"} onValueChange={(v) => setForm({ ...form, campaign_id: v === "none" ? null : v })}>
              <SelectTrigger data-testid="lead-form-campaign"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="none">No campaign</SelectItem>{camps.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent></Select></div>
          <div className="sm:col-span-2 flex justify-end pt-2">
            <Button disabled={busy} data-testid="lead-form-submit">{busy ? "Saving…" : "Save lead"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
